// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2a12d4cc] .el-table {\n  overflow: visible !important;\n}\n[data-v-2a12d4cc] .el-table .has-gutter {\n    font-weight: 700;\n}\n", ""]);
// Exports
module.exports = exports;
